'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/chart.js/src/charts/Chart.Bar.js
// module id = 279
// module chunks = 0